import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Icon from "@material-ui/core/Icon";
import {withStyles} from "@material-ui/core/styles/index";
import Button from "@material-ui/core/Button/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import i18n from "../../i18n";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CardMedia from "@material-ui/core/CardMedia";
import _ from "lodash";
import DialogContent from "@material-ui/core/DialogContent";
import FormAutocomplete from "../Form/FormAutocomplete";

class SetRelations extends React.Component {

    constructor(props) {
        super(props);

        this.initState(true);
    }

    initState(first) {
        let state = {
            file: this.props.file,
            urlLinkOverlay: this.props.urlLinkOverlay,
            urlLinkOverlaySearch: this.props.urlLinkOverlaySearch,
            updateFileRelations: this.props.updateFileRelations,
            searchQuery: '',
            newRelations: [],
            dialogOpen: false,
        };
        if (first && first === true) {
            this.state = state;
        } else {
            this.setState(state);
        }
    }

    handleOpenRelations(e) {
        this.setState({
            dialogOpen: true,
            newRelations: [],
            searchQuery: '',
        });
    }

    handleAssignRelation(item) {
        axios.post(this.state.urlLinkOverlay, {
            'file_id': [this.state.file.sHash],
            'reference_id': item.id || item.value,
            'reference_theme': item.theme,
        }).then((response) => {
            let file = this.state.file;
            if (response.data && response.data.refs) {
                file.aRelations = response.data.refs;
            }
            this.state.updateFileRelations(file);
        });
    }

    handleSubmitButton() {
        this.state.newRelations.map((item) => {
            this.handleAssignRelation(item);
        });
        this.setState({
            dialogOpen: false,
        });
    }

    onCloseClick() {
        this.initState();
    }

    handleClose(e) {

    }

    handleRemoveNewRelationItem(idx) {
        _.pullAt(this.state.newRelations, idx);
        this.setState({
            newRelations: this.state.newRelations,
        })
    }

    renderNewRelations(item, idx) {
        return (
            <ListItem key={item.id || item.value}>
                <Button variant="outlined" onClick={() => this.handleRemoveNewRelationItem(idx)}>
                    <span>{item.name || item.label}</span>
                    <Icon>highlight_off</Icon>
                </Button>
            </ListItem>
        );
    }

    renderOverlay(classes) {
        return (
            <Dialog onClose={this.handleClose.bind(this)}
                    open={this.state.dialogOpen}
                    fullWidth={true}
                    aria-labelledby="simple-dialog-title"
            >
                <DialogTitle id="simple-dialog-title"
                             className={classes.overlayTitle}
                >
                    <Typography variant="h2">
                        <Icon>link</Icon>
                        <span>{i18n.get('file.relations.overlay.title')}</span>
                    </Typography>
                    <Typography variant="subtitle1">
                        {this.state.file.sName || this.state.file.filename}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Button className={classes.close} variant="outlined" color="primary"
                            onClick={this.onCloseClick.bind(this)}><Icon>close</Icon></Button>
                    <Grid container spacing={24}>
                        <Grid item xs={3}>
                            {this.renderPreview(classes, this.state.file)}
                        </Grid>
                        <Grid item xs={7}>
                            <FormAutocomplete
                                name="searchRelation"
                                label={i18n.get('file.relations.overlay.searchCaption')}
                                autoComplete='off'
                                url={this.state.urlLinkOverlaySearch}
                                onChange={(option) => {
                                    if (option && option.value && option.label) {
                                        this.state.newRelations.push(option);
                                        this.setState({
                                            newRelations: this.state.newRelations,
                                        });
                                    }
                                }}
                            />
                            <List>
                                {this.state.newRelations.map((item, idx) => {
                                    return this.renderNewRelations(item, idx);
                                })}
                            </List>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={this.handleSubmitButton.bind(this)}>{i18n.get('default.submit')}</Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        );
    }

    renderPreview(classes, file) {
        if (!file.icon) {
            file.icon = 'file-regular';
        }
        if (file && file.sPrevPic) {
            return (
                <CardMedia
                    className={classes.preview}
                    image={file.sPrevPic}
                    title=""
                />
            )
        }
        return (
            <div className={classes.fileicon}>
                <CardMedia
                    className={classes.fileiconIcon}
                    image={"/images/filetype/" + file.icon + ".svg"}
                    title=""
                />
                <div className={classes.fileiconExt} color="primary">{file.sExt}</div>
            </div>
        );
    }


    renderOpenButton(classes) {
        return (
            <Button variant="outlined" color="primary"
                    className={classes.setRelationButton}
                    onClick={this.handleOpenRelations.bind(this)}>
                <Icon className={classes.iconSpace}>link</Icon>
                {i18n.get('file.relations.overlay.openButton')}
            </Button>
        );
    }

    render() {
        let classes = this.props.classes;
        return (
            <div>
                {this.renderOpenButton(classes)}
                {this.renderOverlay(classes)}
            </div>
        );
    }
}

const styles = theme => ({
    setRelationButton: {
        width: "100%",
    },
    iconSpace: {
        marginRight: theme.spacing.unit * 0.5,
        marginLeft: theme.spacing.unit * 0.5,
    },
    preview: {
        height: 120,
        width: 160,
    },
    fileicon: {
        height: 120,
        width: 160,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: theme.colors.lightGreyBlue,
    },
    fileiconIcon: {
        height: 50,
        width: 50,
        "background-size": "inherit",
    },
    fileiconExt: {
        textAlign: "center",
    },
    hidden: {
        display: "none",
    },
    overlayTitle: {
        position: "relative",
    },
    close: {
        position: "absolute",
        right: 0,
        top: 0,
        padding: 0,
        minWidth: 20,
        minHeight: 20,
    },
});

export default withStyles(styles)(SetRelations);
